import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledTable = styled.div `
    @media only screen and (min-width: 992px) {
        border-radius: 6px;
        background-color: ${props => props.isTransparent ? 'transparent;' : 'white'};
        box-shadow: ${props => {
    if (props.hasBorder) {
        return 'none';
    }
    if (props.hideShadow) {
        return 'none';
    }
    return '0 0 10px rgba(26, 26, 26, 0.11)';
}};
        border: ${props => (props.hasBorder ? '1px solid #f5f5f7;' : 'none')};
    }
`;
const Table = ({ children, className, hasBorder, isTransparent, hideShadow, }) => (_jsx(StyledTable, { className: className, hasBorder: hasBorder, isTransparent: isTransparent, hideShadow: hideShadow, children: children }));
export default Table;
